export const blockingReasonRowSx = {
  bgcolor: 'error.backgroundSoft',
  border: 1,
  borderColor: 'error.borderRegular',
  borderRadius: 0.5,
  pl: 1.5,
  pr: 1,
  py: 1,
  alignItems: 'center',
} as const;

export const blockingReasonIconSx = {
  color: 'error.solid',
  mt: '4px',
} as const;

export const blockingReasonBodySx = {
  flex: 1,
  minWidth: 0,
  pr: 3,
  py: 0.5,
} as const;
